module.exports = __webpack_public_path__ + "static/media/shinawy.f6634094.jpg";